/** Full-screen, centered, unbranded layout shared by the boot-level session screens. */
export const blankSlateStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  gap: '0.75rem',
  padding: '2rem',
  textAlign: 'center',
} as const;
